import React from "react"
import { twMerge } from "tailwind-merge"
import Button, { ButtonProps } from "./Button"

export const secondaryButtonStyles = `
          border border-black
          hover:bg-gray-100 
          bg-white text-black
          focus-visible:outline focus-visible:outline-2 
          focus-visible:outline-offset-2  focus-visible:outline-gray-600
        `

const SecondaryButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, ...props }, ref) => {
  return <Button ref={ref} className={twMerge(secondaryButtonStyles, className)} {...props} />
})
SecondaryButton.displayName = "SecondaryButton"
export default SecondaryButton
